export default `
  mutation startCodeGeneration($boundedContextId: ID!, $workflowId: ID!, $aiVersion: Int, $includeBackend: Boolean, $includeFrontend: Boolean, $specificDomainIds: [String]) {
    startCodeGeneration(boundedContextId: $boundedContextId, workflowId: $workflowId, aiVersion: $aiVersion, includeBackend: $includeBackend, includeFrontend: $includeFrontend, specificDomainIds: $specificDomainIds) {
      success
      message
    }
  }
`
